import React from 'react';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Input from '@amzn/meridian/input';
import Button from '@amzn/meridian/button';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import { KeyboardKeys } from 'src/constants/keyboard-constants';
import { isBlankString } from 'src/utils/string-utils';
import { SCANNER_RESOLUTION_WIDTH } from 'src/constants/responsiveProps';
import './BarcodeScan.scss'

interface BarcodeScanProps {
    shouldRenderImageOrIcon: boolean;
    scanImageOrIcon?: string;
    scanImageAltText?: string;
    shouldRenderText: boolean;
    scanText?: string;
    inputLabel: string;
    inputPlaceholder?: string;
    shouldRenderButton: boolean;
    buttonText?: string;
    buttonIcon?: React.ReactElement;
    onSubmit: (inputValue: string) => void;
    headingTestId?: string;
    inputTestId?: string;
    buttonTestId?: string;
}

interface BarcodeScanState {
    inputValue: string;
}
class BarcodeScan extends React.Component<BarcodeScanProps, BarcodeScanState> {
    constructor(props: BarcodeScanProps) {
        super(props);
        this.state = this.getInitialState();
    }

    private inputTimeoutHandler: ReturnType<typeof setTimeout> | undefined;

    private getInitialState = (): BarcodeScanState => {
        return {
            inputValue: ''
        }
    }

    private onInputChange = (value: string) => {
        this.setState({
            inputValue: value
        })

        if (window.screen.width <= SCANNER_RESOLUTION_WIDTH) {
            if (this.inputTimeoutHandler) {
                clearTimeout(this.inputTimeoutHandler);
            }
            this.inputTimeoutHandler = setTimeout(() => {
                if (this.state.inputValue.length > 2)
                    this.submitInput();
            }, 100);
        }
    }

    private onKeyDown = (event: KeyboardEvent): void => {
        if (isBlankString(this.state.inputValue))
            return;

        if (event.key === KeyboardKeys.ENTER) {
            this.submitInput();
        }
    }

    private submitInput = () => {
        this.props.onSubmit(this.state.inputValue);
        this.setState(this.getInitialState());
    }

    public render() {
        return (
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <div className="barcode-scan">
                        {this.props.shouldRenderImageOrIcon &&
                            <img className="barcode-scan-icon" src={this.props.scanImageOrIcon} alt={this.props.scanImageAltText}/>
                        }
                        {this.props.shouldRenderText && <Text type={props.titleSize} alignment="center" data-testid={this.props.headingTestId}>{this.props.scanText}</Text>}
                        <Input
                            label={this.props.inputLabel}
                            placeholder={this.props.inputPlaceholder}
                            inaccessibleAutoFocus={true}
                            size={props.inputBarSize}
                            value={this.state.inputValue}
                            onChange={this.onInputChange}
                            onKeyDown={this.onKeyDown}
                            data-testid={this.props.inputTestId}
                        />
                        {this.props.shouldRenderButton &&
                            <Button size={props.buttonSize} disabled={isBlankString(this.state.inputValue)} onClick={this.submitInput} data-testid={this.props.buttonTestId}>
                                {this.props.buttonText}
                                {this.props.buttonIcon}
                            </Button>
                        }
                    </div>
                )}
            </Responsive>
        )
    }
}

export default BarcodeScan;
